import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { failedDeliveryAttempt } from "../../instantAnswers/orders-failedDeliveryAttempt";
import { invoiceDetails } from "../../instantAnswers/orders-invoiceDetails";
import { payoutCalculation } from "../../instantAnswers/orders-payoutCalculation";
import { RequestCommissionChanges } from "../../instantAnswers/orders-requestCommissionChanges";
import { returnedToSender } from "../../instantAnswers/orders-returnedToSender";
import { updateTrackingInfo } from "../../instantAnswers/orders-updateTrackingInfo";
import { orderShippedOrDeliveredAndSOYOVisibilityFn, orderShippedStateVisibilityFn } from "../../visibilityFunctions/orderStateVisibilityFn";
export var useOrderShippedBrandNodes = function useOrderShippedBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    ProblemWithDeliveryShippedState: {
      id: "ProblemWithDeliveryShippedState",
      label: strictLocalize({
        id: "+ES+we",
        defaultMessage: [{
          "type": 0,
          "value": "Probleem met bezorging"
        }]
      }),
      children: ["FailedDeliveryAttemptShippedState", "ReturnToSenderShippedState"],
      level: 2,
      isNodeVisible: orderShippedStateVisibilityFn
    },
    FailedDeliveryAttemptShippedState: {
      id: "FailedDeliveryAttemptShippedState",
      label: strictLocalize({
        id: "sm+jd/",
        defaultMessage: [{
          "type": 0,
          "value": "Mislukte bezorgpoging"
        }]
      }),
      level: 2,
      instantAnswer: failedDeliveryAttempt(strictLocalize),
      isNodeVisible: orderShippedOrDeliveredAndSOYOVisibilityFn
    },
    ReturnToSenderShippedState: {
      id: "ReturnToSenderShippedState",
      label: strictLocalize({
        id: "l/7+5Z",
        defaultMessage: [{
          "type": 0,
          "value": "Teruggestuurd naar afzender"
        }]
      }),
      level: 2,
      instantAnswer: returnedToSender(strictLocalize),
      articles: [articles.MyOrders.ORDER_RETURNED_TO_SENDER],
      isNodeVisible: orderShippedStateVisibilityFn
    },
    UpdateTrackingInformationShippedState: {
      id: "UpdateTrackingInformationShippedState",
      label: strictLocalize({
        id: "iuqjNS",
        defaultMessage: [{
          "type": 0,
          "value": "Trackinggegevens bijwerken"
        }]
      }),
      level: 2,
      instantAnswer: updateTrackingInfo(strictLocalize),
      articles: [articles.FulfillingOrders.SHIP_WITH_FAIRE, articles.FulfillingOrders.SHIP_ON_YOUR_OWN],
      isNodeVisible: orderShippedStateVisibilityFn
    },
    PayoutCalculationShippedState: {
      id: "PayoutCalculationShippedState",
      label: strictLocalize({
        id: "/lzS+4",
        defaultMessage: [{
          "type": 0,
          "value": "Berekening voor deze uitbetaling"
        }]
      }),
      level: 2,
      instantAnswer: payoutCalculation(strictLocalize),
      isNodeVisible: orderShippedStateVisibilityFn
    },
    InvoiceDetailsShippedState: {
      id: "InvoiceDetailsShippedState",
      label: strictLocalize({
        id: "OnTwIg",
        defaultMessage: [{
          "type": 0,
          "value": "Factuurgegevens"
        }]
      }),
      level: 2,
      instantAnswer: invoiceDetails(strictLocalize),
      articles: [articles.InvoicesAndBilling.RECEIVE_ORDER_INVOICE],
      isNodeVisible: orderShippedStateVisibilityFn
    },
    RequestCommissionChangesShippedState: {
      id: "RequestCommissionChangesShippedState",
      label: strictLocalize({
        id: "/jYVoe",
        defaultMessage: [{
          "type": 0,
          "value": "Commissiewijziging aanvragen"
        }]
      }),
      level: 2,
      isNodeVisible: orderShippedStateVisibilityFn,
      instantAnswer: RequestCommissionChanges(strictLocalize),
      articles: [articles.FaireDirect.ZERO_COMMISSION]
    }
  };
};